<script lang="ts" setup>
import {computed, onMounted, ref, watch} from "vue";
import {Plan, PlanType} from "@/scripts/types/account";
import useSubscription from "@/scripts/store/subscription";
import Loader from "@/scripts/components/app/common/Loader.vue";
import moment from "moment/moment";
import {InformationCircleIcon} from "@heroicons/vue/20/solid";

interface Props {
    newPlan: PlanType,
    currentPlan: Plan
}

const props = defineProps<Props>()

const subscriptionStore = useSubscription();

const subscriptionMonths = ref(3)
const price = ref(0)
const priceIsUpdating = ref(false)
const isLoading = ref(false)

const isUpgradePlan = computed(() => {
    return props.currentPlan.label === 'pro' && props.newPlan === 'business'
});


const updatePrice = async () => {
    priceIsUpdating.value = true
    if (isUpgradePlan.value) {
        const priceToPay = await subscriptionStore.calculateUpgradePrice(props.newPlan)
        if (priceToPay) {
            price.value = priceToPay.price
        }
    } else {
        const priceToPay = await subscriptionStore.calculateSubscriptionPrice(props.newPlan, subscriptionMonths.value)
        if (priceToPay) {
            price.value = priceToPay.price
        }
    }
    priceIsUpdating.value = false
}

const handleInput = (e) => {
    subscriptionMonths.value = e.target.value;
    updatePrice()
};

const handlePayment = async () => {

    let paymentLink
    isLoading.value = true

    if (isUpgradePlan.value) {
        paymentLink = await subscriptionStore.createUpgradeSubscriptionInvoice(props.newPlan)
    } else {
        paymentLink = await subscriptionStore.createRenewSubscriptionInvoice(props.newPlan, subscriptionMonths.value)
    }

    isLoading.value = false

    if (paymentLink) {
        window.location.href = paymentLink.link
    }
}

onMounted(async () => {
    await updatePrice()
})

watch(() => props.newPlan, async () => {
    await updatePrice()
})

const formatDate = (date) => {
    let months = subscriptionMonths.value
    if (isUpgradePlan.value) {
        months = 0
    }
    return moment(date).add(months, 'M').format("D.M.YYYY")
}

</script>

<template>
    <div class="mt-6">
        <div v-if="!isUpgradePlan">
            <div class="mb-2">Период</div>
            <input @input="handleInput" id="minmax-range" type="range" min="1" max="12" value="3"
                   class="w-full sm:w-6/12 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700">
            <div class="text-sm text-gray-400">продлить на {{ subscriptionMonths }} мес.</div>
        </div>
        <div class="mt-4">
            <div v-if="!priceIsUpdating">
                <div class="rounded-md bg-blue-50 p-4">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <InformationCircleIcon class="h-5 w-5 text-blue-400" aria-hidden="true" />
                        </div>
                        <div class="ml-2 text-sm text-blue-700">
                            <p>Сумма к оплате: <strong>{{ price }}₽</strong></p>
                            <p>
                                У вас будет подключен тариф {{ props.newPlan }} до {{ formatDate(currentPlan.endAt) }}.
                            </p>
                        </div>
                    </div>
                </div>
                <v-button class="mt-4" title="Оплатить" @click="handlePayment" :loading="isLoading"></v-button>
            </div>
            <div v-else>
                <loader></loader>
            </div>
        </div>
    </div>
</template>